function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import _ from 'lodash';
import { theme } from '@arc/frontend/ui-theme';
import { addWordBreaks } from '@arc/frontend/util-common';
import { tokenizeSearchString } from '@arc/shared/util-js';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "qamjgr",
  styles: "margin-right:4px"
} : {
  name: "10cimv1-start",
  styles: "margin-right:4px;label:start;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function HighlightText({
  text = '',
  highlight = '',
  wordBreak = false,
  wordBreakPattern,
  doubleEllipsis = false,
  stacked = false,
  highlightColor = 'yellow',
  lineClamp = false,
  innerRef,
  startAdornment,
  ...props
}) {
  if (!text) return null;
  const start = startAdornment ? <span css={_ref}>{startAdornment}</span> : null;
  if (highlight.length === 0) {
    return <span {...props} ref={innerRef}>
				{start}
				{wordBreak ? addWordBreaks(text, wordBreakPattern) : text}
			</span>;
  }

  // For stacked search, object of highlighted terms which are
  // split by comma, along with corresponding color value
  const highlightedColors = {};
  const highlightedSet = new Set((stacked ? tokenizeSearchString(highlight.toLowerCase()) : highlight.split(' ')).map(word => _.escapeRegExp(word.toLowerCase())).map(word => {
    if (word.startsWith('/')) {
      word = word.slice(1);
    }
    return word;
  }));

  // Populate highlightedColors depending on index
  for (const [idx, word] of [...highlightedSet].entries()) {
    const color = stacked ? theme.getSearchTermColor(idx) : highlightColor;
    highlightedColors[word.toLowerCase()] = color;
  }

  // Split text into parts by highlight text
  const parts = text.split(new RegExp(`(${[...highlightedSet].join('|')})`, 'giu'));
  return <span {...props} ref={innerRef}>
			{start}
			{parts.map((part, i) => {
      // If doubleEllipsis, cut the first part into a smaller piece
      // and ellipse it so highlight can show
      let first;
      const firstThree = parts.slice(0, 3);
      if (i === 0 && doubleEllipsis && firstThree.length >= 3 && highlightedSet.has(firstThree[1].toLowerCase())) {
        if (firstThree[2].split(' ').length < 3) {
          first = part.split(' ').slice(-5).join(' ');
        } else {
          first = part.split(' ').slice(-3).join(' ');
        }
      }
      const highlightedPart = part.toLowerCase();

      /**
       * Use the sematic HTML `<mark>` tag for highlighted text.
       *
       * This is used in tests to find highlighted text.
       */
      const Comp = highlightedSet.has(highlightedPart) ? 'mark' : 'span';
      return <Comp key={i} css={[highlightedSet.has(highlightedPart) ? {
        backgroundColor: highlightedColors[highlightedPart]
      } : undefined, !lineClamp && {
        whiteSpace: 'pre-wrap'
      }, process.env.NODE_ENV === "production" ? "" : ";label:HighlightText;"]}>
						{first && first.length > 3 ? `...${first} ` : wordBreak ? addWordBreaks(part) : part}
					</Comp>;
    })}
		</span>;
}